export interface PrimaryKeyValueModel {
	primaryKey: string;
	primaryKeyValue: string | null;
}
